import { mediaQuery } from 'modules/utils';
import { TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';

export const StyledToastContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9999;

  display: flex;
  flex-direction: column;
  align-items: flex-end;

  width: 100%;

  padding: 0.2rem;

  ${mediaQuery('md')} {
    padding: 0;
    margin: 6rem 1rem 0 0;
  }
`;

export const StyledTransitionGroup = styled(TransitionGroup)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  width: 100%;

  & > * {
    margin-bottom: 0.3rem;
  }

  ${mediaQuery('md')} {
    & > * {
      margin-bottom: 1rem;
    }
  }

  // Animations

  .toast-enter {
    opacity: 0;
  }

  .toast-enter-active {
    opacity: 1;
    transition: opacity 500ms ease-in;
  }

  .toast-exit {
    opacity: 1;
  }

  .toast-exit-active {
    opacity: 0;
    transition: opacity 500ms ease-in;
  }
`;
